export default "__VITE_ASSET__CXSPUElZ__"